import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const StyledAside = styled('aside')`
  @media only screen and (min-width: 768px) {
    min-width: 256px;
  }
`;

const CollapsingAside = styled(StyledAside)`
  @media only screen and (max-width: 767px) {
    border-top: 1px solid ${({ theme }) => theme.gray.medium};
    margin-top: 32px;
    padding-top: 24px;

    section:last-child {
      margin-bottom: 0;
    }
  }
`;

const StyledH1 = styled('h1')`
  border-bottom: 1px solid ${({ theme }) => theme.gray.medium};
  color: ${({ theme }) => theme.text.dark};
  margin: 0 0 24px;
  padding-bottom: 16px;
`;

function Sidebar({ children, border, title, collapseToBottom }) {
  const Component = collapseToBottom ? CollapsingAside : StyledAside;
  return (
    <Component border={border} collapseToBottom={collapseToBottom}>
      {title && <StyledH1>{title}</StyledH1>}
      {children}
    </Component>
  );
}

Sidebar.defaultProps = { title: null };

Sidebar.propTypes = {
  border: PropTypes.bool,
  children: PropTypes.node.isRequired,
  collapseToBottom: PropTypes.bool,
  title: PropTypes.node,
};

Sidebar.defaultProps = {
  border: true,
  collapseToBottom: false,
};

export default Sidebar;
